/**
 * @generated SignedSource<<e68f322103a5a5a955392179e6dba115>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteMyselfInput = {
  brandId: string;
  clientMutationId?: string | null;
};
export type DeleteMyselfButton_DeleteMutation$variables = {
  input: DeleteMyselfInput;
};
export type DeleteMyselfButton_DeleteMutation$data = {
  readonly InfectopharmAuth: {
    readonly deleteMyself: {
      readonly clientMutationId: string | null;
    } | null;
  };
};
export type DeleteMyselfButton_DeleteMutation = {
  response: DeleteMyselfButton_DeleteMutation$data;
  variables: DeleteMyselfButton_DeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "InfectopharmAuthMutations",
    "kind": "LinkedField",
    "name": "InfectopharmAuth",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "DeleteMyselfPayload",
        "kind": "LinkedField",
        "name": "deleteMyself",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "clientMutationId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteMyselfButton_DeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteMyselfButton_DeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5498770119a3f9b9aebc703b949cc2c1",
    "id": null,
    "metadata": {},
    "name": "DeleteMyselfButton_DeleteMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteMyselfButton_DeleteMutation(\n  $input: DeleteMyselfInput!\n) {\n  InfectopharmAuth {\n    deleteMyself(input: $input) {\n      clientMutationId\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "03de329456497105809d218b8ae3b8a5";

export default node;
